import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import useAdd from "../../../../api/useAdd";
import { useTranslation } from "react-i18next";

const Status = ({ open, onClose, token }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
  });
  const { handleAdd, resetForm, loading } = useAdd("status", token);

  useEffect(() => {
    if (resetForm) {
      setFormData({ name: "" });
      onClose();
    }
  }, [resetForm]);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleAdd(formData);
  };
  return (
    <Grid container>
      <Dialog
        open={open}
        onClose={onClose}
        component={"form"}
        onSubmit={handleSubmit}
      >
        <DialogTitle>{t("call_center.addNewStatus")}</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label={t("call_center.status")}
            variant="standard"
            name="name"
            value={formData.name}
            onChange={(e) => {
              setFormData({ name: e.target.value });
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            sx={{ textTransform: "capitalize", margin: "0px 5px" }}
            onClick={onClose}
          >
            {t("call_center.cancel")}
          </Button>
          <Button
            variant="outlined"
            type="submit"
            sx={{ textTransform: "capitalize" }}
            disabled={loading}
          >
            {loading ? t("call_center.saving") : t("call_center.save")}
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default Status;
